import validate from "C:/develop/workspace/aican_v2_ui/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "random-redirect": () => import("C:/develop/workspace/aican_v2_ui/middleware/randomRedirect.js")
}